var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 5.83325H12.3333C7.33333 5.83325 4 8.33325 4 14.1666V25.8333C4 31.6666 7.33333 34.1666 12.3333 34.1666H29C34 34.1666 37.3333 31.6666 37.3333 25.8333V14.1666C37.3333 8.33325 34 5.83325 29 5.83325ZM29.7833 15.9833L24.5667 20.1499C23.4667 21.0333 22.0667 21.4666 20.6667 21.4666C19.2667 21.4666 17.85 21.0333 16.7667 20.1499L11.55 15.9833C11.0167 15.5499 10.9333 14.7499 11.35 14.2166C11.7833 13.6833 12.5667 13.5833 13.1 14.0166L18.3167 18.1833C19.5833 19.1999 21.7333 19.1999 23 18.1833L28.2167 14.0166C28.75 13.5833 29.55 13.6666 29.9667 14.2166C30.4 14.7499 30.3167 15.5499 29.7833 15.9833Z",
    fill: "url(#paint0_linear_133_109)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_109",
    x1: 20.6667,
    y1: 5.83325,
    x2: 20.6667,
    y2: 34.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BE2B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B87F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c96256a13b7792bd23943ab6b534bba8.svg";
export { ForwardRef as ReactComponent };